export default "__VITE_ASSET__C8eo16N1__"